/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface APIToken
 */
export interface APIToken {
    /**
     * 
     * @type {number}
     * @memberof APIToken
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof APIToken
     */
    name: string;
}

export function APITokenFromJSON(json: any): APIToken {
    return APITokenFromJSONTyped(json, false);
}

export function APITokenFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIToken {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
    };
}

export function APITokenToJSON(value?: APIToken | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
    };
}


